import React from "react";
import { View } from "react-native";
import { StyleSheet, Image } from "react-native";
import { Button as _Button } from "src/common/assets/mixins";
import { OrderItem as OrderItemProps } from "src/common/types/response/orders";
import Text from "./text";
import Button from "./button";
import translate from "libs/locale";
import moment from "moment";
import { READABLE_DATE_FORMAT } from "libs/utils/constants";
import { getOrderStatusColor } from "libs/utils/order/orderStatus";

const OrderItem = ({
  data,
  style,
  completedStatus,
  openDetails,
}: {
  data: OrderItemProps;
  style?: object;
  completedStatus: number;
  openDetails: (data: OrderItemProps) => void;
}) => {
  return (
    <View style={styles.container}>
      <Button
        style={[styles.root, style]}
        solid={false}
        onPress={() => openDetails(data)}
      >
        <View style={styles.full}>
          <View style={styles.orderTime}>
            <Text
              style={[
                styles.orderId,
                { color: getOrderStatusColor(data.status) },
              ]}
            >
              {translate("orderId", {
                id: `#${data.uuid}`,
              })}
            </Text>
            <Text style={styles.orderId}>
              {moment(parseInt(data.created)).format(READABLE_DATE_FORMAT)}
            </Text>
          </View>
          <Text style={[styles.orderId, styles.store]}>{data.store_name}</Text>
          {data.items.map((it) => {
            return (
              <Text style={[styles.orderId, styles.item]} key={it.id}>
                {it.name}
              </Text>
            );
          })}
        </View>
        {/* <Button solid={false}>
          <Image
            source={data?.status === completedStatus ? BlueMenu : OrangeMenu}
          />
        </Button> */}
      </Button>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 3
  },
  bottomBar: {
    height: 6,
    flex: 1,
    position: "absolute",
    bottom: -2,
    left: 0,
    right: 0,
  },
  orderTime: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  full: {
    flex: 1,
  },
  root: {
    flex: 1,
    borderRadius: 15,
    backgroundColor: "#FCFCFC",
    marginVertical: 8.25,
    padding: 20,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    flexDirection: "row",
    elevation: 3,
    justifyContent: "space-between",
    alignItems: undefined,
    overflow: "hidden",
  },
  orderId: {
    fontFamily: "MontserratBold",
    fontSize: 14,
    lineHeight: 18,
    color: "#636E72",
  },
  store: {
    fontSize: 12,
    marginTop: 10,
  },
  item: {
    fontFamily: "Montserrat",
    fontSize: 12,
    marginTop: 10,
  },
});

export default OrderItem;
